export function jsonCreateCompany(data, participants) {
  const objectData = {};

  objectData["companyName"] = data["companyName"];
  objectData["companyLabel"] = data["companyLabel"];
  objectData["companyAddress"] = data["companyAddress"];
  objectData["companyZip"] = data["companyZip"];
  objectData["companyCity"] = data["companyCity"];
  objectData["vatId"] = data["vatId"];
  objectData["contact"] = null;

  // check for contact info

  if (
    data.hasOwnProperty("contactFname") &&
    data.hasOwnProperty("contactSname") &&
    data.hasOwnProperty("contactEmail") &&
    data.hasOwnProperty("contactPhone")
  ) {
    const contact = {
      firstName: data["contactFname"],
      lastName: data["contactSname"],
      email: data["contactEmail"],
      phone: data["contactPhone"],
    };
    objectData.contact = contact;
  }

  objectData["participants"] = [];

  let i = 1;
  for (let idx = 0; idx < participants.length; idx++) {
    let participant = {
      firstName: data[`firstName${i}`],
      lastName: data[`lastName${i}`],
      email: data[`email${i}`],
      registrationType:
        data[`registrationType${i}`] === false ? "REDNA" : "SPONZORSKA",
      proceedingsFormat:
        data[`proceedingsFormat${i}`] === false ? "USB" : "KNJIGA",
      tshirt: "NONE",
      tshirtSize: "",
      specialDietary: data[`specialDietary${i}`],
      payload: data[`payload${i}`],
    };

    if (data[`tShirtYesNo${i}`] === true) {
      participant["tshirt"] =
        data[`tShirtType${i}`] === false ? "MALE" : "FEMALE";
      participant["tshirtSize"] = data[`tShirtSize${i}`];
    }

    participant["workshops"] = [];
    if (data[`workshop${i}`] !== null && data[`workshop${i}`] !== false) {
      participant["workshops"].push(data[`workshop${i}`]);
    }

    participant["events"] = [];
    if (data[`event${i}`] !== false) {
      for (let l of data[`event${i}`]) {
        participant["events"].push(l);
      }
    }
    participant["terms"] = [];
    if (data[`terms${i}`] !== false) {
      if (typeof data[`terms${i}`] === "string") {
        participant["terms"].push(data[`terms${i}`]);
      } else if (data[`terms${i}`].length > 1) {
        participant["terms"] = [...data[`terms${i}`]];
      }
    }

    objectData["participants"].push(participant);
    i++;
  }

  return objectData;
}

export function jsonCreateStudent(data) {
  const objectData = {};

  objectData["studyYear"] = data["studyYear"].toString();
  objectData["studentId"] = data["studentId"].toString();
  objectData["email"] = data["email"];
  objectData["lastName"] = data["lastName"];
  objectData["firstName"] = data["firstName"];
  objectData["studyLevel"] = data["studyLevel"];
  objectData["studyProgramme"] = data["studyProgramme"];

  objectData["workshops"] = [];
  if (data["workshop1"] !== null && data["workshop1"] !== false) {
    objectData["workshops"] = [data["workshop1"]];
  }

  // objectData["terms"] = data["terms"] === false ? [] : [...data[`terms`]];

  objectData["terms"] = [];
  if (data[`terms`] !== false) {
    if (typeof data[`terms`] === "string") {
      objectData["terms"].push(data[`terms`]);
    } else if (data[`terms`].length > 1) {
      objectData["terms"] = [...data[`terms`]];
    }
  }

  return objectData;
}
